import 'theme/moydom/less/pages/support.less';
import $ from 'jquery';

$(document).ready(function () {
    console.log('init support page');
    //$('.js-file-upload').fileupload();
});
